import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import cx from 'classnames';
import Icon from '../../Icon/Icon';
import { hideModal, showModal } from './../utils';
import { color } from '../../../styles';
import styles from './Modal.module.scss';
const Modal = ({ handleClose, id, isOpen, hasCloseIcon = true, className, overlayClassName, children, ...props }) => {
    const [isShown, setIsShown] = useState(Boolean(isOpen));
    const onClose = useCallback(() => {
        if (handleClose) {
            handleClose();
        }
        else {
            setIsShown(false);
        }
    }, [handleClose]);
    useEffect(() => {
        const handleShow = (e) => {
            if (id === e.detail.id)
                setIsShown(true);
        };
        const handleHide = (e) => {
            if (id === e.detail.id)
                setIsShown(false);
        };
        document.addEventListener('showModal', handleShow);
        document.addEventListener('hideModal', handleHide);
        return () => {
            document.removeEventListener('showModal', handleShow);
            document.removeEventListener('hideModal', handleShow);
        };
    }, [id]);
    useEffect(() => {
        setIsShown(Boolean(isOpen));
    }, [isOpen]);
    return (_jsxs(ReactModal, { className: cx(styles.modal, className), onRequestClose: onClose, ariaHideApp: false, ...props, overlayClassName: cx(styles.overlay, overlayClassName), isOpen: isShown, children: [hasCloseIcon ? (_jsx(Icon, { onClick: onClose, className: styles.closeIcon, name: "ic_close", color: color('typography', 'light') })) : null, children] }));
};
export default Object.assign(memo(Modal), {
    displayName: 'Modal',
    show: showModal,
    hide: hideModal,
});
